import { serverResponse } from 'app'

import * as actions from './actions'

export default (state = actions.INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case actions.TEAMS_LIST_FETCH: {
      return serverResponse(state, {
        data:
          action.payload.page > 1 &&
          state.originalAction &&
          state.originalAction.payload &&
          state.originalAction.payload.userId === action.payload.userId
            ? state.data
            : [],
        loading: true,
      })
    }
    case actions.TEAMS_LIST_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.TEAMS_LIST_FETCH_ERROR: {
      return serverResponse({ error: action.payload })
    }
    case actions.TEAMS_LIST_FETCH_FULFILLED: {
      return serverResponse(action.payload, {
        data: [...state.data, ...action.payload.data],
        loaded: true,
      })
    }

    case actions.TEAMS_LIST_LIKE: {
      return serverResponse(state, {
        liking: {
          ...(state.liking || {}),
          [action.payload.teamId]: true,
        },
      })
    }
    case actions.TEAMS_LIST_LIKE_CANCELED: {
      return serverResponse(state)
    }
    case actions.TEAMS_LIST_LIKE_ERROR: {
      return serverResponse({ error: action.payload })
    }
    case actions.TEAMS_LIST_LIKE_FULFILLED: {
      const id = action.payload.data[0].team
      const remove = !action.payload.data[0].follow && !action.payload.data[0].like

      const newState = serverResponse(state)
      delete newState.liking[id]

      const team = newState.data.find((i) => i.id === id)
      team.following = remove ? [] : [{ updated_at: new Date().getTime() / 1000 }]

      return newState
    }
    default:
  }
  return state
}
